module.exports = __webpack_public_path__ + "img/menu-transfer-yellow.0df204af.svg";